import multiButtonsSVG from '@plone/volto/icons/grid.svg';
import type { BlockConfigBase } from '@plone/types';
import View from './View';
import Edit from './Edit';
import { MultiButtonsBlockSchema } from './schema';

export interface MultiButtonsBlockItem {
  title?: string;
  description?: string;
  href?: Array<{ '@id'?: string; title?: string }>;
  icon?: string;
  image?: Array<{ '@id'?: string; title?: string }>;
  altText?: string;
  openInNewTab?: boolean;
}

export type MultiButtonsVariant = 'default' | 'card' | 'image';

export interface MultiButtonsBlockData {
  variant?: MultiButtonsVariant;
  buttons?: MultiButtonsBlockItem[];
  maxColumns?: number;
  stretch?: boolean;
  theme?: string;
  styles?: any;
}

const MultiButtonsBlockInfo: BlockConfigBase = {
  id: 'multiButtons',
  // Volto's BlockChooser treats this as an i18n message id.
  title: 'Multi buttons',
  icon: multiButtonsSVG,
  group: 'common',
  view: View,
  edit: Edit,
  blockSchema: MultiButtonsBlockSchema,
  restricted: false,
  mostUsed: false,
  sidebarTab: 1,
  blockHasOwnFocusManagement: false,
};

export default MultiButtonsBlockInfo;
